import { Injectable } from '@angular/core';
import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from '../../shared/service/rest.service';
import { Carrier } from '../model/carrier';


@Injectable()
export class CarrierService extends RestService {

  fetchCarriers(): Observable<Carrier[]> {
    return this.postAndExtract<Carrier>(Carrier, 'api/carriers/gwt/fetch').pipe(
      map(carriers => sortBy(carriers, carrier => carrier.name))
    );
  }
}
